/** Floating launcher + panel (desktop), full-screen sheet (phones / short viewports), and inline full-screen mode. */
export const popup = `
.wk-popup { position: fixed; z-index: var(--wk-z); display: flex; flex-direction: column; align-items: flex-end; gap: .75rem;
  right: max(1.25rem, env(safe-area-inset-right)); bottom: max(1.25rem, env(safe-area-inset-bottom)); }
:host([data-position="left"]) .wk-popup { right: auto; left: max(1.25rem, env(safe-area-inset-left)); align-items: flex-start; }
.wk-launcher { display: inline-flex; align-items: center; gap: .5rem; height: 3.5rem; min-width: 3.5rem; padding: 0 1.125rem 0 1rem; border-radius: 999px;
  background: var(--wk-accent); color: var(--wk-accent-ink); font-weight: 600; font-size: .9375rem; box-shadow: 0 10px 30px rgba(var(--wk-accent-rgb), .35), 0 2px 6px rgba(0,0,0,.15);
  transition: transform .15s ease, box-shadow .15s ease; }
.wk-launcher:hover { transform: translateY(-1px); }
.wk-launcher svg { font-size: 1.375rem; }
.wk-launcher .live-dot { display: none; width: .625rem; height: .625rem; border-radius: 50%; background: var(--wk-ok); box-shadow: 0 0 0 3px rgba(22,163,74,.3); animation: wk-pulse 1.2s ease-in-out infinite; }
.wk-launcher.live .live-dot { display: block; }
.wk-panel { display: none; }
.wk-panel.mounted { display: block; opacity: 0; transform: translateY(.75rem); pointer-events: none; transition: opacity .22s ease, transform .22s ease; }
.wk-panel.open { opacity: 1; transform: none; pointer-events: auto; }
.wk-panel .wk-root { width: min(25rem, calc(100vw - 2.5rem)); height: min(44rem, calc(100dvh - 7rem)); }
.wk-panel .wk-root.wide { width: min(48rem, calc(100vw - 2.5rem)); }

/* full-screen (sheet) — phones, short viewports, or explicit full mode */
.wk-root.full { min-height: var(--wk-placeholder, 0); }
.wk-root.full .wk, .wk-panel.sheet.open .wk {
  position: fixed; inset: 0; z-index: calc(var(--wk-z) + 1); width: auto; height: var(--wk-vvh, 100dvh); max-height: none; border-radius: 0; border: 0;
  padding-top: env(safe-area-inset-top); padding-bottom: env(safe-area-inset-bottom); padding-left: env(safe-area-inset-left); padding-right: env(safe-area-inset-right);
}
.wk-panel.sheet.open .wk-root { width: 100vw; height: var(--wk-vvh, 100dvh); }
.wk-panel.sheet.open { position: fixed; inset: 0; transform: none; }
.wk-popup.sheet-open .wk-launcher { display: none; }
@media (max-width: 40em), (max-height: 34em) {
  .wk-launcher .wk-launcher-label { display: none; }
  .wk-launcher { padding: 0; width: 3.5rem; justify-content: center; }
  .wk-popup { right: max(.875rem, env(safe-area-inset-right)); bottom: max(.875rem, env(safe-area-inset-bottom)); }
  :host([data-position="left"]) .wk-popup { left: max(.875rem, env(safe-area-inset-left)); }
}
`;
